import { Type } from '@angular/core';
import { IntroComponent } from 'src/app/components/intro-component/intro-component.component';
import { MainMenuComponent } from 'src/app/components/main-menu/main-menu.component';
import { HomePageTabsComponent } from 'src/app/pages/home/home-page-tabs/home-page-tabs.component';

/**
 * Constructor type for an Angular component class (e.g. for ngComponentOutlet).
 * Angular does not expose a single public base class that all components extend;
 * component classes are plain constructors whose instances are objects.
 */
export type AngularComponentType = Type<object>;

export interface EnvironmentLayout {
  readonly mainMenuComponent: AngularComponentType;
  readonly homePageTabsComponent: AngularComponentType;
  readonly introComponent: AngularComponentType;
  /** When set, `path: 'healthScore'` redirects here instead of loading HealthScorePage */
  readonly homeHealthScoreRedirectTo?: string;
}

export function createDefaultEnvironmentLayout(): EnvironmentLayout {
  return {
    mainMenuComponent: MainMenuComponent,
    homePageTabsComponent: HomePageTabsComponent,
    introComponent: IntroComponent,
  };
}
